export class User {
  constructor(public name: string = "", public type: number, public token: string) {}

  static fromObject(user: any) {
    return new User(user.name, user.type, user.token);
  }
}
